module.exports = __webpack_public_path__ + "img/map-02.81a1ebb7.svg";